/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { ComponentFactoryResolver, Directive, Input, Type, ViewContainerRef } from '@angular/core';
import { TextElementComponent } from '../elements/text-element/text-element.component';
import { ImageComponent } from '../elements/image/image.component';
import { ButtonComponent } from '../elements/button/button.component';
import { DividerComponent } from '../elements/divider/divider.component';
import { SpacerComponent } from '../elements/spacer/spacer.component';
import { SocialComponent } from '../elements/social/social.component';
import { TBlocks } from '../classes/Elements';
import { TableComponent } from '../elements/table/table.component';

const cStore: Map<string, Type<any>> = new Map();

/**
 * @internal
 *
 * Soon it must be optimized, and load all components lazily.
 */
@Directive({
  selector: '[ipDynamicComponent]'
})
export class DynamicComponentDirective {
  constructor(private cResolver: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef) {
    cStore.set('text', TextElementComponent);
    cStore.set('image', ImageComponent);
    cStore.set('button', ButtonComponent);
    cStore.set('divider', DividerComponent);
    cStore.set('spacer', SpacerComponent);
    cStore.set('social', SocialComponent);
    cStore.set('table', TableComponent);
  }

  @Input() set ipDynamicComponent(block: TBlocks) {
    const component = this.cResolver.resolveComponentFactory(cStore.get(block.type));
    this.viewContainerRef.createComponent(component).instance.block = block;
  }
}
